import { Skeleton } from '@/ui/components/primitives/skeleton'
import { Card, CardContent } from '@/ui/components/primitives/card'
import { PageLayout } from '@/ui/layout'
import { cn } from '@/shared/utils'

/**
 * Skeleton for the user profile page: header + contributions + content grid.
 */
export function ProfileSkeleton() {
  return (
    <PageLayout>
      <div className="min-h-screen bg-background">
        <div className="h-36 w-full bg-earth-100 md:h-56" />
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <Skeleton className="relative -mt-14 h-32 w-32 rounded-full md:-mt-16" />
          <Skeleton className="mt-4 h-8 w-48" />
          <Skeleton className="mt-2 h-4 w-64" />
        </div>

        <div className="mx-auto max-w-6xl px-4 py-8 md:px-6">
          <Card className="mb-8">
            <CardContent className="p-6 space-y-4">
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-40 w-full rounded-md" />
            </CardContent>
          </Card>

          <div className={cn('grid lg:grid-cols-3 gap-8')}>
            <div className="lg:col-span-2 space-y-6">
              <Card>
                <CardContent className="p-6 space-y-4">
                  <Skeleton className="h-6 w-40" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                </CardContent>
              </Card>
            </div>
            <div className="space-y-6">
              <Card>
                <CardContent className="p-6 space-y-4">
                  <Skeleton className="h-6 w-28" />
                  <Skeleton className="h-20 w-full rounded-md" />
                  <Skeleton className="h-4 w-full" />
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
